export const labels = {
	badQualityTextZones: {
		label: "Label.MobileCreator.CheckoutWarning.LowFontSize",

		default:
			"The text of <span>{0} text zones</span> might not fit the text zone because the minumum font size has been reached.",
		// 0: "Number of text zones where the font size has been increased to the minimun font size",
	},
	badQualityPhotoZones: {
		label: "Label.MobileCreator.CheckoutWarning.Resolution",
		default: "<span>{0} photo zones</span> have a low resolution.",
		// 0: "Number of photo zones with a low resolution",
	},
	badQualityPhotoZonesExtraInfo: {
		label: "Label.MobileCreator.CheckoutWarning.Resolution.ExtraInfo",
		default:
			"<span>{0} photo zones</span> have a low resolution. Possible solutions: zoom out or use a better quality image",
		// 0: "Number of photo zones with a low resolution",
	},
	defaultTextInTextZones: {
		label: "Label.MobileCreator.CheckoutWarning.DefaultTextZones",
		default: "Your product contains <span>{0} text field(s)</span> with default text",
		// 0: "Number of text fields that still have default text",
	},
	notAllTextZonesRequired: {
		label: "Label.MobileCreator.CheckoutWarning.EmptyTextZones",
		default: "Your product contains <span>{0} empty text zones</span>.",
		// 0: "Number of text zones without text",
	},
	notMinimumTextZonesFilled: {
		label: "Label.MobileCreator.CheckoutWarning.PctFilledTextZones",
		default:
			"{1}/{2} text zones filled in. You must fill in <span>at least {0} text zones</span>.",
		// 0: "Total number of required text zones",
		// 1: "Total number of filled in text zones",
		// 2: "Total number of fillable text zones",
	},
	notMinimumPhotoZonesFilled: {
		label: "Label.MobileCreator.CheckoutError.PctFilledPhotoZones",
		default:
			"{1}/{2} photo zones filled in. You must fill in <span>at least {0} photo zones</span>.",
		// 0: "Total number of required photo zones",
		// 1: "Total number of filled in photo zones",
		// 2: "Total number of fillable photo zones",
	},
	textOutsideBounds: {
		label: "Label.MobileCreator.CheckoutWarning.TextOutsideZone",
		default:
			"The text might not fit the text zone for {0} textzone(s) and the minimum font size has been reached.",
		// 0: "Number of affected text zones that can be fixed by user"
	},
	allPhotoZonesRequired: {
		label: "Label.MobileCreator.CheckoutError.EmptyPhotoZones",
		default: "All photo zones must be filled. You have <span>{0} empty photo zones</span>.",
		// 0: "Number of empty photo zones",
	},
	rejectedPhotosNotAllowed: {
		label: "Label.MobileCreator.CheckoutError.RejectedPhotos",
		default: "RejectedPhotos",
	},
	emptyPhotoZones: {
		label: "Label.MobileCreator.CheckoutWarning.EmptyPhotoZone",
		default: "<span>{0} empty photo zone(s)</span>.",
		// 0: "Number of empty photo zones",
	},
	splitBookOnPageExceeded: {
		label: "Label.MobileCreator.CheckoutWarning.SplitProduct",
		default:
			"You've added more than {0} pages. You will receive {1} different pocket books with the same cover.",
		// 0: "Number of pages after which the book will be splitted into multiple books.",
		// 1: "Total number of books the customer will receive",
	},
	noQuantity: {
		label: "Label.MobileCreator.CheckoutError.NoQuantity",
		default: "No quantity selected",
	},
	oldStartDate: {
		label: "Label.HTML5Editor.CheckoutWarning.OldStartDate", // TODO: Make separate label for mobile Creator with span
		default: "The <span>start date ({0})</span> of your product is in the past.",
	},
	notAllPhotoZonesOnCoverFilled: {
		label: "Label.MobileCreator.CheckoutWarning.EmptyPhotoZoneOnCover",
		default: "Your product has empty photo zones on the cover page.",
	},
};
